var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      staticClass: "p-4",
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex justify-between w-full" },
                [
                  _c(
                    "div",
                    [
                      _vm.postingActive
                        ? _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("ApplicationNote", {
                                attrs: {
                                  currentUserId: _vm.currentUserId,
                                  applicationId: _vm.applicationId,
                                  jobTitle: _vm.jobTitle,
                                  companyName: _vm.companyName,
                                  location: _vm.location,
                                  employmentType: _vm.employmentType,
                                  duration: _vm.duration,
                                  postedDate: _vm.formattedCreatedAt,
                                  description: _vm.description,
                                  note: _vm.note,
                                  skills: _vm.skillsData,
                                  industries: _vm.industriesData,
                                  postingId: _vm.postingId,
                                  attachedDocumentId: _vm.attachedDocumentId,
                                  buttonVariant: "linkButton",
                                },
                                on: {
                                  applicationNoteUpdated: function ($event) {
                                    return _vm.$emit("applicationNoteUpdated")
                                  },
                                },
                              }),
                              _c("ApplicationAttachment", {
                                attrs: {
                                  currentUserId: _vm.currentUserId,
                                  applicationId: _vm.applicationId,
                                  jobTitle: _vm.jobTitle,
                                  companyName: _vm.companyName,
                                  location: _vm.location,
                                  employmentType: _vm.employmentType,
                                  duration: _vm.duration,
                                  postedDate: _vm.formattedCreatedAt,
                                  description: _vm.description,
                                  skills: _vm.skillsData,
                                  industries: _vm.industriesData,
                                  postingId: _vm.postingId,
                                  attachedDocumentId: _vm.attachedDocumentId,
                                  buttonVariant: "linkButton",
                                },
                                on: {
                                  applicationNoteUpdated: function ($event) {
                                    return _vm.$emit("applicationNoteUpdated")
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm.isCommentExists
                        ? _c("UIButton", {
                            attrs: {
                              buttonText: "Remove My Comments",
                              variant: "linkButton",
                            },
                            on: { click: _vm.removeComments },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  !_vm.isCanceledStatus
                    ? _c("UIButton", {
                        attrs: {
                          processing: _vm.processing,
                          buttonText: "Revoke",
                          variant: "linkButton",
                        },
                        on: { click: _vm.revokeApplication },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col w-full" },
        [
          _c(
            "div",
            { staticClass: "flex items-baseline" },
            [
              _vm.postingActive
                ? _c(
                    "RouterLink",
                    {
                      staticClass: "flex items-center",
                      attrs: {
                        to: {
                          name: _vm.applicationDetailsRouteName,
                          params: { id: _vm.postingId },
                        },
                      },
                    },
                    [
                      _c("CircleWithInitials", {
                        staticClass: "mr-2",
                        attrs: { title: _vm.jobTitle },
                      }),
                      _c(
                        "p",
                        {
                          staticClass:
                            "font-bold text-base hover:text-primary-500 mb-2",
                        },
                        [_vm._v(_vm._s(_vm.jobTitle))]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _c("CircleWithInitials", {
                        staticClass: "mr-2",
                        attrs: { title: _vm.jobTitle },
                      }),
                      _c(
                        "div",
                        { staticClass: "flex items-baseline pb-2" },
                        [
                          _c("p", { staticClass: "font-bold text-base mr-2" }, [
                            _vm._v(_vm._s(_vm.jobTitle)),
                          ]),
                          _c("Badge", {
                            attrs: {
                              value: "Posting deactivated",
                              color: _vm.BadgeColor.DANGER,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _vm.interviewedBy
                ? _c(
                    "Tooltip",
                    {
                      staticClass: "ml-auto",
                      attrs: {
                        title: _vm.interviewTooltipText,
                        tooltipClasses: "w-56",
                      },
                    },
                    [
                      _vm.interviewedBy
                        ? _c("Badge", {
                            attrs: {
                              value: "Interview",
                              color: _vm.BadgeColor.INFO,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex ml-10 flex-wrap -mt-1" },
            [
              _c(
                "div",
                { staticClass: "flex flex-col w-72 xxlLabelContainer mr-5" },
                [
                  _c(
                    "CardBodyItem",
                    { attrs: { label: "Company" } },
                    [
                      _c(
                        "RouterLink",
                        {
                          staticClass: "overflow-hidden",
                          attrs: {
                            to: {
                              name: _vm.routes.NETWORK_COMPANY,
                              params: { id: _vm.postingCompanyId },
                            },
                          },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "font-bold text-base hover:text-primary-500 truncate",
                            },
                            [_vm._v(" " + _vm._s(_vm.companyName) + " ")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("CardBodyItem", {
                    attrs: { label: "Location", content: _vm.location },
                  }),
                  _c("CardBodyItem", {
                    attrs: {
                      label: "Employment type",
                      content: _vm.employmentType,
                      customAlign: "items-center",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex flex-col w-64" },
                [
                  _vm.postingDuration
                    ? _c("CardBodyItem", {
                        attrs: {
                          label: "Duration",
                          content: _vm.postingDuration,
                          wide: "",
                        },
                      })
                    : _vm._e(),
                  _c("CardBodyItem", {
                    attrs: {
                      label: "Posted date",
                      content: _vm.formattedCreatedAt,
                      wide: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "CardBodyItem",
                {
                  staticClass: "w-64 flex-1 xsLabelContainer mr-5",
                  attrs: { label: "Skills" },
                },
                [
                  _c("ItemChipsWithMore", {
                    attrs: {
                      items: _vm.skillsData,
                      navigateTo: _vm.navigateToDetails,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "CardBodyItem",
            {
              staticClass: "ml-10 xxlLabelContainer",
              attrs: { label: "Description" },
            },
            [
              _c("CollapsibleDescription", {
                attrs: { description: _vm.description },
              }),
            ],
            1
          ),
          _c(
            "CardBodyItem",
            {
              staticClass: "ml-10 xxlLabelContainer",
              attrs: { label: "My Comments" },
            },
            [
              _c("CollapsibleDescription", {
                attrs: { description: _vm.note },
              }),
            ],
            1
          ),
          _vm.attachedDocumentName
            ? _c("CardBodyItem", {
                staticClass: "ml-10 xxlLabelContainer",
                attrs: { label: "My Attachment" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ textClasses }) {
                        return [
                          _c("DocumentProvider", {
                            attrs: {
                              document: _vm.attachedDocument,
                              currentUserRole: _vm.currentUserRole,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ download }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "flex items-center" },
                                        [
                                          _c("span", { class: textClasses }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.attachedDocumentName
                                                ) +
                                                " "
                                            ),
                                          ]),
                                          _c(
                                            "ColorIconContainer",
                                            {
                                              staticClass: "h-6 w-6",
                                              on: { click: download },
                                            },
                                            [_c("DownloadIcon")],
                                            1
                                          ),
                                          _c(
                                            "ColorIconContainer",
                                            {
                                              staticClass: "h-6 w-6",
                                              attrs: { iconStyle: "" },
                                              on: { click: _vm.detachDocument },
                                            },
                                            [_c("DetachIcon")],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3969830918
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }